/**
 *
 * Demos:
 *
 * - [Autocomplete](https://ui-packages.isbuildingluma.com/ui-core/react-autocomplete/)
 *
 * API:
 *
 * - [Autocomplete API](https://ui-packages.isbuildingluma.com/ui-core/api/autocomplete/)
 * - inherits [MuiAutocomplete API](https://mui.com/material-ui/api/autocomplete/)
 *
 * Styles:
 *
 * - [Proto](https://www.figma.com/file/3aiZqfuzFOiRoveGwK0Yod/Next-IA?node-id=1765%3A76530&mode=dev)
 */
const MuiAutocomplete = {
  styleOverrides: {
    root: {
      '& .MuiOutlinedInput-root': {
        padding: '5px 9px',
        '& .MuiInputAdornment-positionStart': {
          paddingLeft: '6px'
        }
      }
    },
    listbox: ({
      theme
    }) => ({
      '& .Mui-focused': {
        backgroundColor: `${theme.palette.background.default} !important`
      },
      '&::-webkit-scrollbar-track': {
        marginBlock: theme.spacing(3)
      },
      '&::-webkit-scrollbar-thumb': {
        width: 0
      },
      '& > li': {
        paddingInline: theme.spacing(3),
        paddingBlock: theme.spacing(2),
        borderRadius: theme.spacing()
      },
      paddingInline: theme.spacing(1.5),
      paddingBlock: theme.spacing(3)
    }),
    paper: ({
      theme
    }) => {
      var _theme$shadows;
      return {
        borderRadius: `${theme.spacing(2)} !important`,
        boxShadow: (_theme$shadows = theme.shadows) == null ? void 0 : _theme$shadows[5],
        paddingInline: theme.spacing(1.5)
      };
    },
    popper: ({
      theme
    }) => ({
      paddingBlock: `${theme.spacing(0.5)} !important`
    })
  }
};
export default MuiAutocomplete;